
import Vue, { PropType } from 'vue';
import { Client, Site } from '@/interfaces/multiTenancy';

export default Vue.extend({
	data() {
		return {
			selectedClient: null,
			selectedSite: null,
		} as {
			selectedClient: Client | null;
			selectedSite: Site | null;
		};
	},

	props: {
		clients: {
			type: Array as PropType<Client[]>,
			default: (): Client[] => [],
		},
		sites: {
			type: Array as PropType<Site[]>,
			default: (): Site[] => [],
		},
	},

	mounted() {
		if (this.clients.length === 1) {
			this.pickClient(this.clients[0]);
		}
	},

	methods: {
		pickClient(client: Client) {
			this.selectedClient = client;
			const totalSites = this.filterSites(client);
			if (totalSites.length === 1) {
				this.selectedSite = totalSites[0];
				this.sendSelectedItems();
			}
		},

		pickSite(site: Site) {
			this.selectedSite = site;
			this.sendSelectedItems();
		},

		sendSelectedItems() {
			if (this.selectedClient && this.selectedSite) {
				this.$emit('selectedTenancies', { client: this.selectedClient, site: this.selectedSite });
			}
		},

		filterSites(client: Client): Site[] | [] {
			return this.sites.filter((site: Site) => site.fk_client === client.id);
		},

		unselectClient() {
			this.selectedClient = null;
		},
	},
});
